<template>
  <footer class="container">
    <p>
      Copyright &copy; 2016-{{ year }} Garage Rats Car Club. All Rights Reserved.
      <!-- &middot; garagerats@outlook.com -->
    </p>
    <!-- <p>
      <router-link :to="{ name: 'PrivacyPolicy' }" class="nav-link">Privacy</router-link>
    </p> -->
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter',
  data() {
    return {
      year: (new Date()).getFullYear()
    }
  }
}
</script>

<style scoped>
footer {
  font-family: 'Open Sans', sans-serif;
  background-color: #fff;
  color: #888;
  text-align: center;
  font-size: 0.8em;
  padding-top: 20px;
  padding-bottom: 20px;
}
</style>